var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h6',{staticClass:"text-h5 font-weight-bold white--text text--lighten-1 d-flex align-center"},[_c('div',{staticClass:"rounded-pill purple lighten-1 me-2 px-2 d-flex align-center justify-center py-2 elevation-3"},[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v(_vm._s(_vm.titleIcon))])],1),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }